import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["patternurl", "color"],
  _excluded2 = ["backgroundImage", "backgroundColor"];
import PropTypes from 'prop-types';
import { Component } from 'react';
import styled from 'styled-components';
import { getPatternUrl, PATTERNS } from '../utils/templateHeaderPatternUtils';
import { EMPTY_STRING } from '../../constants/SharedConstants';
import { getGradientSecondaryColor, getLinearGradientStyle, GRADIENT_TYPE } from 'knowledge-content-ui/constants/TemplateEditorConstants';
import { List } from 'foundations-components/transitional/components/List';
import { SelectableButton } from 'foundations-components/transitional/components/SelectableButton';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const Button = props => {
  return /*#__PURE__*/_jsx(SelectableButton, Object.assign({
    block: true,
    marginBlockEnd: "100",
    blockSize: "128px",
    inlineSize: "100%",
    maxInlineSize: "100%",
    position: "relative",
    overflow: "hidden"
  }, props));
};

// @bend-expect trellis-tokenized
const Pattern = styled.div.withConfig({
  displayName: "PatternField__Pattern",
  componentId: "d99hoh-0"
})(["background-image:url(", ");background-size:cover;width:100%;height:100%;position:absolute;top:0;left:0;&&&{background-color:", ";}"], props => props.patternurl, props => props.color);

// @bend-expect trellis-tokenized
const Gradient = styled.div.withConfig({
  displayName: "PatternField__Gradient",
  componentId: "d99hoh-1"
})(["background-image:", ";width:100%;height:100%;position:absolute;top:0;&&&{background-color:", ";}"], ({
  backgroundImage
}) => backgroundImage, ({
  backgroundColor
}) => backgroundColor);
const PatternButton = _ref => {
  let {
      patternurl,
      color
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(Button, Object.assign({}, props, {
    children: /*#__PURE__*/_jsx(Pattern, {
      patternurl: patternurl,
      color: color
    })
  }));
};
const GradientButton = _ref2 => {
  let {
      backgroundImage,
      backgroundColor
    } = _ref2,
    props = _objectWithoutPropertiesLoose(_ref2, _excluded2);
  return /*#__PURE__*/_jsx(Button, Object.assign({}, props, {
    children: /*#__PURE__*/_jsx(Gradient, {
      backgroundImage: backgroundImage,
      backgroundColor: backgroundColor
    })
  }));
};
class PatternField extends Component {
  constructor(...args) {
    super(...args);
    this.getOnChange = value => () => this.props.onFieldChange(value);
  }
  render() {
    const {
      color,
      gradientType,
      imageSrc,
      readOnly
    } = this.props;
    return /*#__PURE__*/_jsxs(List, {
      styled: false,
      children: [/*#__PURE__*/_jsx("li", {
        children: /*#__PURE__*/_jsx(PatternButton, {
          color: color,
          selected: !gradientType && !imageSrc,
          onSelectedChange: this.getOnChange({
            gradientType: undefined,
            imageSrc: EMPTY_STRING
          }),
          readOnly: readOnly
        })
      }), /*#__PURE__*/_jsx("li", {
        children: /*#__PURE__*/_jsx(GradientButton
        // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
        , {
          backgroundColor: getGradientSecondaryColor(GRADIENT_TYPE.LIGHT),
          backgroundImage: getLinearGradientStyle(GRADIENT_TYPE.LIGHT, color),
          selected: gradientType === GRADIENT_TYPE.LIGHT,
          onSelectedChange: this.getOnChange({
            gradientType: GRADIENT_TYPE.LIGHT,
            imageSrc: undefined
          }),
          readOnly: readOnly
        })
      }), /*#__PURE__*/_jsx("li", {
        children: /*#__PURE__*/_jsx(GradientButton
        // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
        , {
          backgroundColor: getGradientSecondaryColor(GRADIENT_TYPE.DARK),
          backgroundImage: getLinearGradientStyle(GRADIENT_TYPE.DARK, color),
          selected: gradientType === GRADIENT_TYPE.DARK,
          onSelectedChange: this.getOnChange({
            gradientType: GRADIENT_TYPE.DARK,
            imageSrc: undefined
          }),
          readOnly: readOnly
        })
      }), PATTERNS.map((pattern, index) => {
        const valueToUse = getPatternUrl(pattern.value, color);
        return /*#__PURE__*/_jsx("li", {
          children: /*#__PURE__*/_jsx(PatternButton, {
            color: color,
            name: pattern.patternName,
            patternurl: valueToUse,
            selected: imageSrc === valueToUse,
            onSelectedChange: this.getOnChange({
              gradientType: undefined,
              imageSrc: valueToUse
            }),
            readOnly: readOnly
          })
        }, index);
      })]
    });
  }
}
PatternField.propTypes = {
  color: PropTypes.string.isRequired,
  // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
  gradientType: PropTypes.oneOf[(GRADIENT_TYPE.DARK, GRADIENT_TYPE.LIGHT)],
  imageSrc: PropTypes.string,
  onFieldChange: PropTypes.func.isRequired,
  readOnly: PropTypes.bool.isRequired
};
export default PatternField;